export const ntd = (cents: number): string =>
  `NT$${(cents / 100).toLocaleString('zh-TW')}`;

export const dt = (iso: string): string =>
  new Date(iso).toLocaleString('zh-TW', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });

export const STAGE_LABEL: Record<string, string> = {
  BOOKED: '已預約',
  CHECKIN: '已報到',
  CONSULT: '諮詢中',
  TREATING: '療程中',
  DONE: '已完成',
  CANCELLED: '已取消',
};

export const newKey = (): string =>
  `web-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
